import React from 'react';


const Loader = () => {

    return (
        <div className='loaderMain' >
            <div className="loader"></div>
        </div>
    )
};

export default Loader;